import { styled } from "@mui/material/styles";
import { DataGridPro, DataGridProProps, GridLogicOperator } from "@mui/x-data-grid-pro";

const StyledDataGrid = styled(DataGridPro)(({ theme }) => ({
    '& .MuiDataGrid-columnHeader': {
        padding: '0 16px',
        fontWeight: 600,
        color: '#333333'
    },
    '& .MuiDataGrid-columnHeaderTitle': {
        fontWeight: 600,
        color: '#333333'

    },
    '& .MuiDataGrid-row': {
        padding: '0 6px',
        '--rowBorderColor': 'transparent',
    },
    '.MuiDataGrid-cellContent': {
        pointerEvents: 'none',
    },
    '.MuiDataGrid-menuIcon': {
        opacity: 'inherit !important',
        visibility: 'visible',
        width:'auto'
    },
    '& .MuiDataGrid-cell.grid-cell-display-block': {
        display: 'block',
        padding: '10px 0',

        'div:not(:first-child)':  {
            marginTop: '5px'
        }
    },
}));

const CentralDataGridPro = (props: DataGridProProps) => {
    return (
        <>
            <StyledDataGrid {...props} slotProps={{panel: {placement: "bottom-end"}, ...props.slotProps}}/>
        </>
    );
}

export default CentralDataGridPro;